const CalendarIcon = (props) => {
    return (
        <svg
          width={40}
          height={40}
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#clip0_52_3)" fill="#6e0202">
            <path d="M10.156 7.031h-.781v2.344h.781V7.031zm3.906.782h-3.124v.78h3.124v-.78zm3.126 0h-.782v.78h.782c.43 0 .78.35.78.782v7.422c0 .431-.35.781-.78.781H7.813a.782.782 0 01-.782-.781V9.375c0-.431.35-.781.782-.781h.78v-.781h-.78c-.863 0-1.563.7-1.563 1.562v7.422c0 .863.7 1.562 1.563 1.562h9.375c.862 0 1.562-.7 1.562-1.562V9.375c0-.863-.7-1.563-1.563-1.563zm-1.563-.782h-.781v2.344h.781V7.031z" />
            <path d="M9.375 10.938a.782.782 0 100 1.563.782.782 0 000-1.563zm3.125 0a.782.782 0 100 1.563.782.782 0 000-1.563zm3.125 1.562a.782.782 0 100-1.563.782.782 0 000 1.563zm-6.25 1.563a.782.782 0 100 1.563.782.782 0 000-1.563zm3.125 0a.782.782 0 100 1.563.782.782 0 000-1.563zm3.125 0a.782.782 0 100 1.563.782.782 0 000-1.563z" />
          </g>
        </svg>
      )
}

export default CalendarIcon